import React, { useEffect } from 'react';
import 'styles/components/main/Intro.scss';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useNavigate } from 'react-router-dom';

const Intro = ({ moreThan768 }) => {

    const navigate = useNavigate();

    useEffect(() => {
        AOS.init({
            duration: 700
        });
    });

    return (
        <div id='Intro-wrapper'>
            <section className='Intro'>
                <p className='intro-text1'>어질인소프트는</p>
                <div className='intro-text2'>
                    {moreThan768 ? (
                        <>
                            <p className='fc_grey' data-aos='fade-up'>다양한 기반기술과 경험으로</p>
                            <p className='fc_grey' data-aos='fade-up'>고객의 니즈를 완벽하게 수용하고</p>
                            <p data-aos='fade-up'>나와 지역사회의 성장을 이루어가는 기업입니다</p>
                        </>
                    ) : (
                        <>
                            <p className='fc_grey' data-aos='fade-up'>다양한 기반기술과 경험으로</p>
                            <p className='fc_grey' data-aos='fade-up'>고객의 니즈를 완벽하게 수용하고</p>
                            <p data-aos='fade-up'>나와 지역사회의 성장을 </p>
                            <p data-aos='fade-up'>이루어가는 기업입니다</p>
                        </>
                    )}
                </div>
                <div className='container'>
                    <button className='intro-goIntroBtn' onClick={() => navigate('/company?tab=introduce')}>소개 바로가기</button>
                </div>
            </section>
        </div>
    );
};

export default React.memo(Intro);